import {useMemo} from 'react'
import type {StartConversationInfo} from './use-start-conversation-info'

export function useCommentDialogTitle(info: StartConversationInfo) {
  return useMemo(() => {
    let text = ''

    if (info.isMultiline) {
      const startSideIdentifier = info.startSide === 'left' ? 'L' : 'R'
      const endSideIdentifier = info.side === 'left' ? 'L' : 'R'
      text += ` lines ${startSideIdentifier}${info.startLineNumber} to ${endSideIdentifier}${info.lineNumber}`
    } else {
      const sideIdentifier = info.side === 'left' ? 'L' : 'R'
      text += ` line ${sideIdentifier}${info.lineNumber}`
    }

    return text
  }, [info.isMultiline, info.lineNumber, info.side, info.startLineNumber, info.startSide])
}
